import { render, staticRenderFns } from "./namespace-tree-row.vue?vue&type=template&id=62c1ac5e&scoped=true"
import script from "./namespace-tree-row.vue?vue&type=script&lang=js"
export * from "./namespace-tree-row.vue?vue&type=script&lang=js"
import style0 from "./namespace-tree-row.vue?vue&type=style&index=0&id=62c1ac5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c1ac5e",
  null
  
)

export default component.exports